module.exports = __webpack_public_path__ + "static/anylitics-dashboard-fad1ec684ea06544926ea2381be21ed4.png";